export default __webpack_public_path__ + "static/after-98827f374d42fb32b9f045e0a23bfd04.png";